import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import permissionReducer from "../features/permissions/permissionSlice";

export default combineReducers({
    auth: authReducer,
    permissions: permissionReducer,
});
